import { active } from "@api/users/active/path";
import { deactive } from "@api/users/deactive/path";
import { employeeCosts } from "@api/users/employeeCosts/path";
import { me } from "@api/users/me/path";
import { setPassword } from "@api/users/setPassword/path";
import { warehouses } from "@api/users/warehouses/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/users/`;
const pathById = `${pathBase}:userId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const users = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  me,
  warehouses,
  setPassword,
  active,
  deactive,
  employeeCosts,
};
